<template>
    <div id="lonewolf-header">
        <div class="lonewolf-page-header">
            <div class="row">
                <div class="col-sm">
                    <img alt="Sellers Shield logo" height="160" width="400" :src="loneWolfLogoSrc"/>
                </div>
                <div class="col-sm">
                    <h1 style="white-space: nowrap; font-weight: bold; font-family: 'Poppins';">Digital Disclosure
                        Process</h1>
                    <span style="font-size: 30px; text-align: left;">Powered by: <img height="40" width="200"
                                                                                      alt="Sellers Shield logo"
                                                                                      :src="sellersShieldLogo"/></span>
                </div>
            </div>
        </div>
        <!-- <div class="lonewolf-page-subheader">
            <div style="padding: 10px;">
                <h4>Login or create an account with SellersShield&trade; to link your LoneWolf transaction.</h4>
                <p>(You only have to do this once)</p>
            </div>
        </div> -->
    </div>
</template>

<script>
import './LonewolfHeader.scss';

export default {
    name: "LonewolfHeader",
    data: () => ({
        loneWolfLogoSrc: require('@assets/images/lonewolf_logo.png'),
        sellersShieldLogo: require('@assets/images/SS-logo.png'),
    }),
}
</script>